import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider, Typography } from '@mui/material';
import { NodeEdgeMapper } from '@iotv/datamodel-core';
import { AdjacentType } from '@iotv/iotv-v3-types';
import { TabPanel } from '@mui/lab';
import { useContext, useState } from 'react';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { denseTreeAdornmentTheme } from '../../../../cosmetics/Themes/DenseTreeAdornment';
import { TypeIcons } from '../../../../Iconography';
import { ObjectTree } from '../../../../v2/components/generic/ObjectTree';
import { customerDeviceGroupStep } from '../../../navigation/TreeDefinitions/DeviceGroups';
const debug = process.env.REACT_APP_DEBUG && false;
export const FilteredTree = ({ value }) => {
    return (_jsxs(TabPanel, { value, children: [_jsx(Typography, { variant: 'h6', children: "Filter test" }), _jsx(Tree, {})] }, 'batchPut'));
};
const Tree = () => {
    const [appContext] = useContext(AppMainViewContext);
    const { contextCustomer, TransactionFunctions } = appContext;
    const [nodeEdgeMapper, setNodeEdgeMapper] = useState(new NodeEdgeMapper());
    const allSks = [];
    const allNodeIds = nodeEdgeMapper.getContainedItems().map((item) => item.sk);
    debug && console.log(`PropertyAreaPlaceSelector AllNodeIds: ${allNodeIds.length}`, 'expanded');
    const [selectedNodeIds, setSelectedNodeIdsX] = useState(allSks);
    return (_jsx(ThemeProvider, { theme: denseTreeAdornmentTheme, children: contextCustomer && (_jsx(ObjectTree, { nodeEdgeMapper,
            queryPaths: [customerPropertyAreaPlacePath, customerDeviceGroupStep],
            contextObjects: [contextCustomer],
            transactionFunctions: TransactionFunctions,
            hideTopStep: true,
            selectedNodeIds,
            expanded: allNodeIds,
            orderByName: true,
            maxVisibleNodes: 5 }, `propertyAreaPlace`)) }));
};
const placeSubPath = {
    stepQuery: {
        objectTypeId: 'Place',
        adjacencyType: AdjacentType.CHILD,
        edgeTypeId: undefined,
    },
    endIcon: TypeIcons.Place,
    nextSteps: [],
};
const customerPropertyAreaPlacePath = {
    renderTypeFolder: false,
    stepQuery: {
        objectTypeId: 'Property',
        adjacencyType: AdjacentType.CHILD,
        edgeTypeId: undefined,
    },
    endIcon: TypeIcons.Property,
    nextSteps: [
        {
            stepQuery: {
                objectTypeId: 'Area',
                adjacencyType: AdjacentType.CHILD,
            },
            endIcon: TypeIcons.Area,
            nextSteps: [placeSubPath],
        },
        placeSubPath,
    ],
};
